import React from 'react'
import healthcare1 from '../images/finsight1.png';
import healthcare2 from '../images/finsight2.png';
import healthcare3 from '../images/coresync3.png';
import OurPartner from '../pages/components/OurPartner';

function FinSightX() {
    return (
        <>
            <section id="portfolio" className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">
                        <span className="highlight-orange">FinsightX </span> – AI-Powered Financial Intelligence Platform
                    </div>
                </div>
            </section>

            <section className="container my-5">
                {/* Section 1: Project Overview */}
                <div className="row g-0 overflow-hidden shadow rounded">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare1}
                            alt="FinsightX Financial Intelligence"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">FinsightX</span> – AI-Powered Financial Intelligence Platform
                        </h1>

                        <p className="mb-3 ps-1">
                            FinsightX is a next-generation AI platform designed to empower financial institutions and decision-makers with real-time insights,
                            risk analysis, and intelligent forecasting. Built for agility and scale, FinsightX provides dynamic dashboards, automated data pipelines,
                            and predictive modeling to drive smarter financial strategies.
                        </p>

                        <p className="mb-3 ps-1">
                            Whether it's portfolio analysis, market trend prediction, or compliance monitoring, FinsightX transforms raw financial data into actionable
                            intelligence—reducing manual effort, enhancing accuracy, and enabling faster decisions in today’s fast-moving markets.
                        </p>

                        <p className="mb-4 ps-1">
                            It also includes a custom-built logistics management platform to streamline global freight operations—from shipment tracking to
                            real-time analytics—offering automated workflows and secure document handling for better efficiency and customer satisfaction.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>

                {/* Section 2: Summary & Team Info */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Client:</span> A FinTech Company
                        </h1>

                        <h4 className="fw-bold mb-1 highlight-orange">Country</h4>
                        <p className="mb-3 ps-3">USA</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Project Scope & Technology</h4>
                        <p className="mb-3 ps-3">
                            Crew AI, OpenAI, Pinecone, Langchain, ReactJS, MongoDB, Node.js
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Industry</h4>
                        <p className="mb-3 ps-3">Financial</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Team Composition</h4>
                        <p className="mb-3 ps-3">
                            1 UI/UX Designer, 2 Frontend Developers, 2 Backend Developers, 1 Quality Analyst, 1 Business Analyst, 2 AI Developers
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Work Duration</h4>
                        <p className="mb-4 ps-3">3 Months</p>

                        <p className="mb-4 ps-3">
                            FinsightX is designed to streamline and modernize financial analysis and reporting through AI. It empowers finance teams, analysts,
                            and executives to extract insights from complex datasets with speed and precision. Users can upload financial reports, transaction data,
                            or regulatory documents, and the platform instantly provides forecasts, risk assessments, and performance insights—cutting decision cycles
                            from weeks to minutes.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>

                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare2}
                            alt="FinsightX Financial Dashboard"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>
                </div>

                {/* Section 3: Process & Key Features */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare3}
                            alt="FinsightX AI Process"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3">
                            <span className="highlight-orange">Process</span>
                        </h1>

                        <p className="mb-3 ps-1">
                            Our team architected FinsightX using modern AI/ML frameworks to process structured and unstructured financial data from diverse sources.
                            We integrated secure pipelines for ingesting transaction data, compliance reports, and market feeds.
                        </p>

                        <p className="mb-3 ps-1">
                            A strong focus was placed on data normalization, anomaly detection, and predictive modeling — all while ensuring a seamless and intuitive
                            dashboard for analysts and leadership teams.
                        </p>

                        <h4 className="fw-bold mb-2 highlight-orange">Key Features</h4>
                        <ul className="ps-3 mb-4">
                            <li className="mb-1">AI-driven financial document parsing and normalization</li>
                            <li className="mb-1">Real-time performance and trend analytics dashboards</li>
                            <li className="mb-1">Predictive modeling for forecasting and risk mitigation</li>
                            <li className="mb-1">Compliance tracking and intelligent alerts</li>
                        </ul>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Get Started
                        </a>
                    </div>
                </div>

                <OurPartner />
            </section>

        </>
    )
}

export default FinSightX